import React from 'react'

const map = {
  Finished: { bg: 'bg-customDarkGreen', text: 'text-customFontMilkWhite' },
  Upcoming: { bg: 'bg-customBlue', text: 'text-customFontMilkWhite' },
  Live: { bg: 'bg-customLightYellow2', text: 'text-customFontMilkWhite' },
  Postponed: { bg: 'bg-customFontRed', text: 'text-customFontMilkWhite' },
  Freezed : {bg: 'bg-customHeader', text: 'text-customFontMilkWhite'},
  Five : { bg: 'bg-customFontGold', text: 'text-customBlack' },
  Eight : { bg: 'bg-customFontYellow', text: 'text-customPrimaryText' },
}

const StatusBadge = ({ value, type = null }) => {
  const m = map[value] || map.Finished
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-semibold ${m.bg} ${m.text} italic`}>
      {value === 'Five' ? '5% Tax' : value === 'Eight' ? '8% Tax' : type === 'Single' ? 'Single Freezed' : type === 'Parlay' ? 'Parlay Freezed' : value }
    </span>
  )
}

export default StatusBadge

